import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

export const wrapperContainerCss: CSSObject = {
  position: "relative",
};

export const confirmWrapperCss: CSSObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  backgroundColor: `${ui.white[700]}90`,
};

export const modalActionCss: CSSObject = {
  height: "378px",
  width: "480px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const actionContainerCss: CSSObject = {
  position: "relative",
  width: "100%",
  backgroundColor: ui.white[700],
  border: `1px solid ${ui.neutral[100]}`,
  borderRadius: "8px",
  paddingTop: "32px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "16px",

  ...typographyStyles.fontFamily.circular,
};

export const actionButtonsCss: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  padding: "0 12px 12px",
};

export const closeButtonCss: CSSObject = {
  position: "absolute",
  top: "0",
  right: "8px",
  cursor: "pointer",
  background: "none",
  border: "none",
  padding: "12px",
};

export const modalHeaderCss: CSSObject = {
  width: "100%",
  borderBottom: `1px solid ${ui.neutral[100]}`,
  marginTop: "8px",
};

export const confirmationTextCss: CSSObject = {
  padding: "24px",
};
